// extracted by mini-css-extract-plugin
export default {"box":"Social_box__PfWcw"};